import { createValidationSchema, validate, validateIfFile } from "@";

export const schema = createValidationSchema({
  url: validate("url", "url"),
  section: validate("req", "section"),
  image: validateIfFile("image", "imageUrl"),
});

export const defaultValues = {
  url: "",
  id: null,
  section: 0,
  image: "",
  imageUrl: "",
  isActive: false,
};
